import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import 'flowbite';

// import Lenis from 'lenis';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

gsap.registerPlugin(ScrollTrigger);


// Make Lenis global
// window.lenis = new Lenis({
//     duration: 1.2,
//     smoothWheel: true
// });


// function raf(time) {

//     window.lenis.raf(time);

//     requestAnimationFrame(raf);

// }

// requestAnimationFrame(raf);


// Update ScrollTrigger on Lenis scroll
// window.lenis.on('scroll', ScrollTrigger.update);


// Stop Lenis when modal opens
// window.addEventListener('modal-opened', () => {

//     // document.body.style.overflow = 'hidden';
//     // document.documentElement.style.overflow = 'hidden';

//     window.lenis.stop();

// });


// Restart Lenis when modal closes
// window.addEventListener('modal-closed', () => {

//     // document.body.style.overflow = '';
//     // document.documentElement.style.overflow = '';

//     window.lenis.start();

// });



const modal = document.getElementById('modal-container');

if (modal) {

    if (window.innerWidth < 768) {

        gsap.from(modal, {
            y: "100%",
            duration: 0.4,
            ease: "power4.out"
        });

    } else {

        gsap.from(modal, {
            scale: 0.95,
            opacity: 0,
            duration: 0.25
        });

    }

}


 const successCheckmark = document.querySelector('.success-checkmark');

if (successCheckmark) {

    gsap.from(successCheckmark, {
        scale: 0,
        duration: 0.5,
        ease: "back.out(2)"
    });

}
